export var SectionFieldPath;
(function (SectionFieldPath) {
    SectionFieldPath["category"] = "category";
    SectionFieldPath["deleted"] = "deleted";
    SectionFieldPath["orderIndex"] = "orderIndex";
})(SectionFieldPath || (SectionFieldPath = {}));
export var isSection = function (doc) {
    return doc != null && doc.ref.parent.id.startsWith('section');
};
//# sourceMappingURL=section.js.map